import trackcoMdl from "./trackco.mdl"

export default [...trackcoMdl];